import React, { useState } from 'react'
import { Anchor } from '@zendeskgarden/react-buttons'
import { Modal, Close } from '@zendeskgarden/react-modals'
import { XXXL } from '@zendeskgarden/react-typography'
import styled from 'styled-components'
import { Row, Col } from '@zendeskgarden/react-grid'

import FlashNotification from '../shared/FlashNotification'
import ManageSubscriptionRequest from './ManageSubscriptionRequest'

const StyledLogo = styled.img`
  width: 70px
  height: 64px
`

const StyledLink = styled.a`
  display: flex;
  justify-content: left;
  width: 20%;
`

const StyledHeader = styled.div`
  margin: 20px 0;
  width: 950px;
  display: flex;
  ${({ env }) => env === 'development' && `background-color: F6DE86`}
  ${({ env }) => env === 'staging' && `background-color: E86C64`}
  ${({ env }) => env === 'pre_prod' && `background-color: 49A15E`}
`

const StyledEnvLabel = styled.div`
  ${({ env }) => env === 'production' && `display: none;`}
`

const StyledAnchor = styled(Anchor)`
  display: flex;
  align-items: center;
  width: 20%;
  white-space: nowrap
  margin-top: 25px
`
const StyledLinks = styled.div`
  white-space: nowrap
  margin-top: 10px
  text-align: right
`

const StyledRow = styled(Row)`
  text-align: right
  justify-content: flex-end
`

const StyledPageTitle = styled(XXXL)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60%;
`

const Header = ({ env, subdomain, flash, setSuccessFlash, setErrorFlash, removeFlash }) => {
  const [subscriptionManageShowing, setSubscriptionManageShowing] = useState(false)

  const onModalClose = () => {
    setSubscriptionManageShowing(false)
  }

  if (!subscriptionManageShowing) {
    return (
      <div>
        <StyledHeader env={env}>
          <StyledLink href="https://www.zendesk.com" target="__blank">
            <StyledLogo src="img/Zendesk_logo_RGB.svg" />
          </StyledLink>
          <StyledPageTitle>Zendesk Status</StyledPageTitle>
          <Col size="2">
            <StyledRow>
              <StyledLinks>
                <StyledAnchor
                  onClick={() => setSubscriptionManageShowing(true)}>
                  Manage subscriptions
                </StyledAnchor>
              </StyledLinks>
            </StyledRow>
            <StyledRow>
              <StyledLinks>
                <StyledAnchor href="https://support.zendesk.com/hc/en-us/articles/4408824499866-Monitoring-your-account-status-with-the-Zendesk-Status-page" target="_blank">About</StyledAnchor>
              </StyledLinks>
            </StyledRow>
          </Col>
        </StyledHeader>
        <StyledEnvLabel env={env}>{env}</StyledEnvLabel>
        <FlashNotification flash={flash} removeFlash={removeFlash} />
        <div style={{ float: "clear" }}/>
      </div>
    )
  }
  return (
    <Modal onClose={onModalClose} medium animate>
      <ManageSubscriptionRequest
        subdomain={subdomain}
        onClose={onModalClose}
        setSuccessFlash={setSuccessFlash}
        setErrorFlash={setErrorFlash}
      />
      <Close aria-label="Close modal" />
    </Modal>
  )
}

export default Header
